import React, { PropsWithChildren } from 'react';

import bem from '../../../lib/bemUtils/bem';

export const BADGE_TYPE = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  EDITMODE: 'editmode',
  PUBLISHED_HISTORY: 'publishedHistory',
  TEMPLATE: 'template',
} as const;

type PageManagementBadgeProps = PropsWithChildren<{
  ariaHidden?: boolean;
  badgeType: (typeof BADGE_TYPE)[keyof typeof BADGE_TYPE];
}>;

export function PageManagementBadge({ ariaHidden, badgeType, children }: PageManagementBadgeProps) {
  return (
    <p aria-hidden={ariaHidden} className={`${bem('pagemanagement__badge', badgeType)}`}>
      {children}
    </p>
  );
}
